import { useEffect } from 'react';

import { Spinner } from '../../components/Spinner';
import { useEntitlements } from '../../contexts/useEntitlements';
import { useError } from '../../contexts/useError';
import { getErrorStatusCode } from '../../utils/errorUtils';

import { DownloadHomeInfo } from './components/DownloadHomeInfo';
import { DownloadHomeTable } from './components/DownloadHomeTable';
import './DownloadHomePage.scss';

export const DownloadHomePage = () => {
  const { entitlements, error, isError, isLoading } = useEntitlements();

  const { setError } = useError();

  // TODO: CT3004T-191 - Add error context management during loading state

  useEffect(() => {
    if (isError && error) {
      const statusCode = getErrorStatusCode(error);

      setError({ statusCode });
    }
  }, [isError, error, setError]);

  if (isError) {
    return null;
  }

  if (isLoading || !entitlements) {
    return (
      <div className="full-page-container">
        <Spinner text="" />
      </div>
    );
  }

  return (
    <>
      <div className="download-home-page">
        <DownloadHomeInfo />
        <DownloadHomeTable />
      </div>
    </>
  );
};
